import { addProps, addDisplayName, flowMax, addHandlers } from 'ad-hok'
import { FC } from 'react'
import { CustomLink as CmsCustomLink } from 'shared/src/api/types'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { BODY_MEDIUM_STYLE, LABELS_STYLE } from '../styles'
import { IconButton } from '../IconButton'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 6,
    background: 'rgba(54, 52, 50, 0.02)',
    border: '1px solid rgba(144, 115, 79, 0.08)',
    borderRadius: 2,
    height: 64,
    cursor: 'pointer',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  label: {
    ...LABELS_STYLE,
    color: 'rgba(54, 52, 50, 0.8)',
  },
  name: {
    ...BODY_MEDIUM_STYLE,
    color: 'rgba(54, 52, 50, 0.8)',
  },
  deleteIcon: {
    color: '#90734F',
  },
})

interface Props {
  link: CmsCustomLink
  onEdit: () => void
  onDelete: () => void
  disabled?: boolean
  className?: string
}

export const CustomLink: FC<Props> = flowMax(
  addDisplayName('CustomLink'),
  addHandlers({
    onDelete:
      ({ onDelete }) =>
      (event: MouseEvent) => {
        event.stopPropagation()
        onDelete()
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({
    link: { name, url, imageId },
    onEdit,
    onDelete,
    disabled,
    classes,
    className,
    t,
  }) => (
    <div onClick={onEdit} className={cx(classes.container, className)}>
      <div className={classes.textContainer}>
        <div className={classes.label}>
          {t('admin.account.userCustomLinks.label')}
        </div>
        <div className={classes.name}>{imageId ? url : name}</div>
      </div>
      <IconButton
        name="close"
        onClick={onDelete}
        addHitSlop
        iconClassName={classes.deleteIcon}
        disabled={disabled}
      />
    </div>
  )
)
